import { render } from "./NotFound.vue?vue&type=template&id=a5bf5aec"
const script = {}
script.render = render

export default script